<template>
    <footer>
    <div class="footer-logo">
        <img width="150px" src="@/assets/logo.png" alt="Tribal Logo">
    </div>
    
    <nav class="ml-auto">
    
    </nav>
</footer>
</template>


<script>
   export default{

   }
</script>

<style>
    footer{
        height: 50vh;
        width: 100vw;
        background-color: #040034;
        position: relative;
    }

    .footer-logo{
        position: absolute;
        top: 40%;
        right: 46%;
    }

    .footer-logo img{
        width: 120px;
    }

</style>